var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnowledgeBase({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4713 55.6202C50.0582 55.2304 66.6233 55.1349 83.1695 55.3317C84.3113 55.112 85.5561 55.4521 85.9602 56.0958C86.0443 56.2429 86.0849 56.3977 86.0795 56.5524V64.3753C86.2314 64.7918 85.9927 65.2216 85.4476 65.5139C84.9079 65.7966 84.1567 65.9113 83.438 65.8196C67.8546 66.1558 52.2522 65.9743 36.7068 65.277C35.4701 65.3095 34.2551 65.0726 33.3194 64.6141C32.8828 64.2798 32.5926 63.8901 32.4787 63.4775V63.1718C31.9525 61.441 31.7139 59.6854 31.76 57.9279V56.8753L33.4713 55.6202Z",
    fill: "#C2C4CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.471 76.0127C50.0579 75.623 66.6231 75.5275 83.1693 75.7243C84.311 75.5046 85.5559 75.8446 85.9599 76.4884C86.044 76.6355 86.0847 76.7903 86.0793 76.945V84.7679C86.2311 85.1844 85.9925 85.6142 85.4474 85.9065C84.9077 86.1892 84.1564 86.3038 83.4377 86.2121C67.8543 86.5484 52.252 86.3669 36.7065 85.6696C35.4698 85.7021 34.2548 85.4652 33.3192 85.0067C32.8825 84.6724 32.5923 84.2827 32.4784 83.87V83.5644C31.9523 81.8336 31.7136 80.078 31.7597 78.3205V77.2678L33.471 76.0127Z",
    fill: "#C2C4CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.9406 65.9433L87.36 52.1088C87.36 52.1088 28.9817 51.0729 30.5496 52.1088C32.1174 53.1448 30.5496 66.879 30.5496 66.879L86.9406 65.9433Z",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3487 31.6783C71.9248 31.2478 76.4949 31.1423 81.0598 31.3597C81.3748 31.117 81.7182 31.4926 81.8297 32.2037C81.8529 32.3662 81.8641 32.5371 81.8626 32.708V41.3488C81.9045 41.8088 81.8387 42.2836 81.6883 42.6064C81.5394 42.9187 81.3321 43.0453 81.1338 42.944C76.8346 43.3154 72.5301 43.115 68.2413 42.3448C67.9001 42.3806 67.5649 42.119 67.3068 41.6126C67.1863 41.2433 67.1062 40.8128 67.0748 40.3571V40.0195C66.9297 38.1077 66.8638 36.1685 66.8765 34.2273V33.0646L67.3487 31.6783Z",
    fill: "#C2C4CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.9406 90.0341L87.36 76.1997C87.36 76.1997 28.9817 75.1637 30.5496 76.1997C32.1174 77.2356 30.5496 90.9698 30.5496 90.9698L86.9406 90.0341Z",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4957 23.661C25.4957 23.661 24.3443 89.3015 25.5511 101.57C26.7579 113.838 26.0454 111.247 39.6767 111.922C53.3081 112.596 88.3415 112.596 90.8521 111.078C93.3626 109.56 93.9608 100.285 93.8407 92.5294C93.7206 84.7739 95.8268 44.7608 94.6316 35.9922C89.2915 31.2299 80.7377 24.3317 75.6833 19.1758C59.1822 19.85 25.5519 19.793 25.5519 19.793C25.5519 19.793 25.5372 19.5878 25.4957 23.661Z",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8554 11.3447C47.871 14.251 46.9495 21.5514 46.1119 24.8384C43.2848 30.5472 37.9446 25.3574 40.1435 25.3574C41.9026 25.3574 42.1329 23.2814 42.0282 22.2435V14.4587C38.137 10.3068 36.2185 13.9397 35.7457 16.2751C35.5363 20.8595 35.1175 31.3776 35.1175 36.7751C35.1175 43.5219 40.7717 44.5599 40.7717 39.889C40.7717 35.2181 44.8554 33.1422 46.7401 35.4776C48.6248 37.8131 47.3683 44.3004 40.1435 45.8574C34.3636 47.1029 31.8716 44.1274 31.3481 42.4839C31.1387 35.7371 30.8455 20.4789 31.3481 13.4207C35.7458 4.0789 41.0859 7.7118 44.8554 11.3447Z",
    fill: "#F4F4F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2627 23.6341C45.9669 27.8684 42.1951 27.5698 40.3462 26.8912C39.8121 26.2466 39.1629 24.9369 40.8392 24.8555C42.5156 24.774 42.6882 23.4644 42.5649 22.8198V16.2037C42.7703 14.9823 42.3923 12.5394 39.2368 12.5394C36.0814 12.5394 35.2103 14.9823 35.1692 16.2037V39.7791C36.5251 44.6649 42.1951 43.5452 42.0719 38.8631C41.9732 35.1174 44.496 35.7416 45.7697 36.522C46.6325 39.3381 46.7558 45.1738 40.3462 45.9881C33.9366 46.8024 31.6768 43.5452 31.3481 41.8149V13.4555C36.06 4.95704 43.599 8.28904 46.2627 13.1502C46.386 14.8805 46.5586 19.3998 46.2627 23.6341Z",
    stroke: "#70758F",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3125 19.3037H41.0857L37.5088 20.7345L36.4358 23.5959L40.728 31.465L50.3855 28.2459L49.3125 19.3037Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9397 19.6611H49.3126",
    stroke: "#70758F",
    strokeWidth: 1.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2192 29.0228V19.3652L94.2584 35.6451C90.6713 36.013 82.7245 36.528 79.6341 35.6451C76.5437 34.7621 75.4032 30.8623 75.2192 29.0228Z",
    fill: "#F4F4F5",
    stroke: "#70758F",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3816 106.282C34.3816 106.282 37.8247 99.5889 43.3701 100.259C47.429 100.75 49.569 104.817 49.569 104.817L57.0078 102.538",
    stroke: "#70758F",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeBase);
export default __webpack_public_path__ + "static/media/knowledge-base.c3f150677cd99e821e8ee9df2a379969.svg";
export { ForwardRef as ReactComponent };